export const CarouselCollectionType = {
  RECOMMENDATIONS: 'recommendations',
  RELATED_COURSE: 'related-courses',
  DEGREES: 'degrees',
} as const;

export default CarouselCollectionType;
